import "../../styles/Offerings/OfferingService.css";
import AdditionalService from "./AdditionalService";

const services = [
  {
    src: "/prototype.svg",
    title: "Prototype \nCreation",
    desc: "Figma/Website",
  },
  {
    src: "/pitch-deck.svg",
    title: "Pitch Deck \nCreation",
    desc: "Investor-Ready",
  },
  {
    src: "/growth.svg",
    title: "Product \nDevelopment",
    desc: "MVP & Full-Scale",
  },
  {
    src: "/leadership.svg",
    title: "Executive \nCoaching",
    desc: "Leadership & Strategy",
  },
  {
    src: "/automation1.svg",
    title: "Business \nAutomation",
    desc: "Tech-Driven Scaling",
  },
];
const OfferingService = () => {
  return (
    <div className="offeringservice-container">
      <div className="offeringservice-innercontainer">
        <div className="offeringservice-title">Additional Paid Services</div>
        <div className="offeringservice-desc">Need more specialized support? We’ve got you covered!</div>
        <div className="offeringservice-additionalservices-container">
          {services.map((service, index) => (
            <AdditionalService key={index} data={service} />
          ))}
        </div>
        <div className="additionalBtn">
        <a href="https://blogs.lovencoders.com/request-a-quote/" target="_blaml" style={{textDecoration:"none", color:"white"}}>
          Request a Custom Quote
        </a>
        </div>
      </div>
    </div>
  );
};

export default OfferingService;
